/**
 * Kebab-case slug helper for generating stable identifiers from
 * human-readable names.
 */
export function slugify(str) {
    return str
        .toLowerCase()
        .replace(/[''"]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
//# sourceMappingURL=slug-utils.js.map